import { render, staticRenderFns } from "./template-selector-modal.vue?vue&type=template&id=4090035a&scoped=true"
import script from "./template-selector-modal.vue?vue&type=script&lang=js"
export * from "./template-selector-modal.vue?vue&type=script&lang=js"
import style0 from "./template-selector-modal.vue?vue&type=style&index=0&id=4090035a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4090035a",
  null
  
)

export default component.exports